import React from "react";
import { Typography, Box, Button, ListItem, List } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from 'prop-types';
import FolderImage from './iconFolder';
import Checkbox from '../checkbox';
import icArrowRight from '../assets/icons/icChevronRight.png';

const useStyles = makeStyles((theme) => ({
    iconPopover: {
        minWidth: 30
    },
    root: {
        color: theme.palette.text.secondary,
        backgroundColor: 'white',
        display: 'flex',
        flexDirection: 'row',
        paddingLeft: theme.spacing(1)
    },
    name: {
        fontFamily: "UniviaPro",
        fontSize: "13px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: 1.25,
        letterSpacing: "0.13px",
        marginLeft: theme.spacing(2.5),
        color: "#4f5064",
    },
    iconContainer: {
        padding: 7,
        minWidth: 'unset',
        backgroundColor: '#e5f1f8',
        position: 'absolute',
        top: 26,
        right: 16
    },
    icon: {
        width: 16,
        height: 16
    },
}));

function TableCategoryOnly({ getCategory, item, onCheck, permissions, pickerMode }) {
    const classes = useStyles();

    const onClick = () => {
        if (item.type === 'Folder') {
            getCategory(item.id);
        }
    }

    const onCheckboxClick = e => {
        e.stopPropagation();
        onCheck(item.id);
    }

    return (
        <List style={{ paddingTop: 10, paddingBottom: 0 }}>
            <ListItem className={classes.root} button onClick={onClick}>
                <Box flex={0.5} className={classes.childItem} px={1}>
                    {
                        (permissions && pickerMode === 'menu' && permissions.isCreate && !item.locked) ? (
                            <Checkbox
                                onClick={onCheckboxClick}
                                checked={item.checked}
                            />
                        ) : (
                                <Checkbox
                                    style={{ opacity: 0 }}
                                    disabled={true}
                                    onClick={onCheckboxClick}
                                    checked={item.checked}
                                />
                            )
                    }
                </Box>
                <Box flex={1} className={classes.childItem}>
                    <FolderImage iconURL={item.iconURL} />
                </Box>
                <Box flex={8} className={classes.childItem} style={{ paddingRight: 8 }}>
                    <Typography className={classes.name}>{item.name}</Typography>
                </Box>
                <Box flex={1}></Box>
            </ListItem>
            <Button className={classes.iconContainer} onClick={onClick}>
                <img alt='' src={icArrowRight} className={classes.icon} />
            </Button>
        </List>
    );
}

TableCategoryOnly.propTypes = {
    getCategory: PropTypes.func.isRequired,
    item: PropTypes.object.isRequired,
    onCheck: PropTypes.func.isRequired,
};

export default TableCategoryOnly;
